import { render, staticRenderFns } from "./InvoiceRecordDetail.vue?vue&type=template&id=bd53a5b0&scoped=true"
import script from "./InvoiceRecordDetail.vue?vue&type=script&lang=js"
export * from "./InvoiceRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRecordDetail.vue?vue&type=style&index=0&id=bd53a5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd53a5b0",
  null
  
)

export default component.exports